module.exports = __webpack_public_path__ + "static/silver-orange-logo-5941583ae0bab47ea27fd07c9bbc7ed9.png";